import React from "react";
import {Link, useLocation} from "react-router-dom";
import DashIcon from "components/icons/DashIcon";

export function SidebarLinks({ routes }) {
  const location = useLocation();

  const isActiveRoute = (routeName) => location.pathname === routeName;

  const getLinkClasses = (isActive) => {
    return isActive
        ? "font-bold text-navy-700 dark:text-white"
        : "font-medium text-gray-600";
  };

  const getBasePath = (path) => {
    const basePath = path.split("/")[0];
    return `/${basePath}`;
  };

  const generateLinks = () => {
    return routes.map((route, index) => {
      const basePath = getBasePath(route.path);
      // Some routes (e.g. GREAT Analytics) override the link target via
      // `linkTo` so the nav opens a specific in-page view (Summary).
      const target = route.linkTo ? `${route.layout}${route.linkTo}` : `${route.layout}${basePath}`;
      const isActive =
        isActiveRoute(target) ||
        isActiveRoute(route.layout + basePath) ||
        (basePath !== "/" && location.pathname.startsWith(`${route.layout}${basePath}/`)) ||
        (basePath === "/" && ["/", "/summary", "/inbound", "/outbound"].includes(location.pathname));

      return (
          <Link key={index} to={target}>
            <div className="relative mb-2 flex hover:cursor-pointer">
              <li className="flex items-center px-4 py-2 rounded-md transition">

                <span className={`text-lg ${getLinkClasses(isActive)}`}>
                  {route.icon || <DashIcon className="h-2 w-2"/>}
                </span>

                <p className={`text-sm ml-3 font-medium ${getLinkClasses(isActive)}`}>
                  {route.name}
                </p>

              </li>

              {isActive && (
                  <div className="absolute right-0 top-1 h-7 w-1 rounded-lg bg-brand-500 dark:bg-brand-400"/>
              )}
            </div>
          </Link>
      );
    });
  };

  return generateLinks();
}

export default SidebarLinks;
